export enum SyncRunStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  PARTIAL = "PARTIAL",
  STARTED = "STARTED",
  FAILED = "FAILURE",
}

export interface SyncRunFailure {
  detail: string;
  employeeName: string;
  reason: string;
}

export interface SyncRun {
  id: string;
  run_id: string;
  status: SyncRunStatus;
  start: string;
  end: string | null;
  channel?: "BATCH" | "ADHOC";
  creations: number;
  updates: number;
  failed_creations: number;
  failed_updates: number;
  blocked: number;
  unblocked: number;
  failed_records?: SyncRunFailure[];
}

export interface SyncRunsResponse {
  count: number;
  pages: number;
  total_creations: number;
  total_updates: number;
  total_failed_creations: number;
  total_failed_updates: number;
  results: SyncRun[];
}

export interface SyncRunsSummary {
  total_creations: number;
  total_updates: number;
  total_failed_creations: number;
  total_failed_updates: number;
}
